// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__22_eN","label":"SetPasswdForm_label__15M5_"};